import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Search, Target, UserSquare2, Download, Plus } from "lucide-react";
import { META_FILTER_ALL, META_FILTER_OPTIONS, CONSULTOR_FILTER_ALL, CONSULTOR_FILTER_NONE } from "./constants";

export default function CondominiosToolbar({ t, isProsp, search, setSearch, tipoFilter, setTipoFilter, metaFilter, setMetaFilter, consultorFilter, setConsultorFilter, isVend, myVendedorName, vendedores, handleExport, openCreate }) {
  return (
    <div className="rounded-xl border border-border bg-card p-4 flex flex-col lg:flex-row lg:items-center gap-3">
      <div className="relative flex-1 min-w-0">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
        <Input
          data-testid="input-search-condominios"
          placeholder="Buscar por condomínio ou vendedor…"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="pl-9"
        />
      </div>
      <Select value={tipoFilter} onValueChange={setTipoFilter}>
        <SelectTrigger className="w-full lg:w-[180px]" data-testid="filter-tipo-condominio">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="todos">Todos os tipos</SelectItem>
          <SelectItem value="residencial">Residencial</SelectItem>
          <SelectItem value="comercial">Comercial</SelectItem>
        </SelectContent>
      </Select>
      {t === "atendido" && (
        <Select value={metaFilter} onValueChange={setMetaFilter}>
          <SelectTrigger className="w-full lg:w-[220px]" data-testid="filter-meta-condominio">
            <div className="flex items-center gap-2 truncate">
              <Target className={`w-3.5 h-3.5 shrink-0 ${metaFilter === META_FILTER_ALL ? "text-muted-foreground" : "text-primary"}`} />
              <SelectValue />
            </div>
          </SelectTrigger>
          <SelectContent>
            {META_FILTER_OPTIONS.map((opt) => (
              <SelectItem key={opt.value} value={opt.value} data-testid={`filter-meta-opt-${opt.value}`}>
                {opt.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      )}
      <Select
        value={consultorFilter}
        onValueChange={setConsultorFilter}
      >
        <SelectTrigger
          className="w-full lg:w-[220px]"
          data-testid="filter-consultor-condominio"
        >
          <div className="flex items-center gap-2 truncate">
            <UserSquare2 className="w-3.5 h-3.5 text-muted-foreground shrink-0" />
            <SelectValue placeholder="Todos os consultores" />
          </div>
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={CONSULTOR_FILTER_ALL}>Todos os consultores</SelectItem>
          <SelectItem value={CONSULTOR_FILTER_NONE}>Sem consultor</SelectItem>
          {isVend && myVendedorName && (
            <SelectItem value={myVendedorName} data-testid="filter-consultor-opt-me">
              Só os meus ({myVendedorName})
            </SelectItem>
          )}
          {vendedores.filter((v) => v !== myVendedorName).map((v) => (
            <SelectItem key={v} value={v} data-testid={`filter-consultor-opt-${v}`}>{v}</SelectItem>
          ))}
        </SelectContent>
      </Select>
      <div className="flex gap-2">
        <Button variant="outline" onClick={handleExport} data-testid="btn-export-csv-condominios">
          <Download className="w-4 h-4 mr-2" /> Exportar CSV
        </Button>
        <Button onClick={openCreate} data-testid="btn-add-condominio">
          <Plus className="w-4 h-4 mr-2" />
          {isProsp ? "Novo prospecto" : "Novo atendido"}
        </Button>
      </div>
    </div>
  );
}
